<template>
  <div class="general">
    <div class="heading">
      {{$ml.get(`Change Password`)}}
    </div>
    <div class="middle">
      <app-text-input
        :label="$ml.get(`New Password`)"
        :type="'password'"
        v-model="form.pass"
      />
      <app-text-input
        :label="$ml.get(`Confirm Password`)"
        :type="'password'"
        v-model="form.confirm"
      />

      <div>
        <app-btn @click="save">
          {{ $ml.get(`save`) }}
        </app-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        pass: '',
        confirm: ''
      }
    }
  },
  methods: {
    save () {
      if (this.form.pass == '' || this.form.confirm == '')
        return this.$notify({group: 'notices', title: this.$ml.get('Not all fields are filled!'), type: 'error'});

      if (this.form.pass != this.form.confirm)
        return this.$notify({group: 'notices', title: this.$ml.get('Fields do not match!'), type: 'error'});

      if (this.form.pass.length < 6)
        return this.$notify({group: 'notices', title: this.$ml.get('Minimum password length 6!'), type: 'error'});

      this.$store.dispatch('subAccount/savePassword', this.form.pass).then(res => {
        this.$notify({group: 'notices', title: this.$ml.get('Password was successfully updated!'), type: 'success'});
      }).catch(err => {
        this.$notify({group: 'notices', title: this.$ml.get('Password was not updated!'), type: 'error'});
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.general {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 23px;

  @media (max-width: 640px) {
    align-items: center;
  }

  .heading {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    color: #4C5056;
    margin-bottom: 15px;
    padding-left: 20px;
  }

  .middle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    >div {
      margin: 22px 20px;
      width: calc(50% - 40px);
      min-width: 250px;
    }
  }
}
</style>
